import React from "react";
import { useState, useEffect } from "react";
import TMG_VIDEO from "../Project Images/TMG_VIDEO.mp4"

export const InitialVideo = ({onVideoEnd }) => {

  useEffect(() => {
    const videoElement = document.getElementById("fullscreenVideo");

    const handleVideoEnd = () => {
      onVideoEnd();
    };

    if (videoElement) {
      videoElement.addEventListener("ended", handleVideoEnd);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("ended", handleVideoEnd);
      }
    };
  }, [onVideoEnd]);
  
  return (
    <div>
      <video
          id="fullscreenVideo"
          autoPlay
          muted
          style={{
            width: "110%",
            height: "120vh",
            objectFit: "cover",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: -1,
          }}
        >
          <source src={TMG_VIDEO} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
    </div>
  );
};
